<template>
  <!-- 购物车 -->
  <div class="cart" style="padding-bottom: 110px">
    <van-sticky>
      <van-nav-bar
        title="购物车"
        left-text="返回"
        :right-text="`${isEdit ? '完成' : '编辑'}`"
        @click-left="$router.go(-1)"
        @click-right="isEdit = !isEdit"
        left-arrow
      ></van-nav-bar>
    </van-sticky>

    <!-- 购物车为空时显示 -->
    <van-empty v-show="cartList.length === 0" class="bg-fff h100pc">
      <template #description>
        <div v-if="isLogin">
          <span>购物车空空如也</span>
          <router-link to="/" class="base ml-5">回首页</router-link>
        </div>
        <div v-else>
          <span>您还没登录,</span>
          <router-link to="/login" class="base ml-5">去登录</router-link>
        </div>
      </template>
    </van-empty>

    <!-- 列表 -->
    <van-checkbox-group v-model="result" ref="checkboxGroup">
      <div class="flx-cent" v-for="(item, index) in cartList" :key="index">
        <van-checkbox
          :name="item.cartId"
          checked-color="#C03131"
          icon-size="15px"
          @change="selectOne"
        ></van-checkbox>

        <div @click="toDetail(item)" class="fg1 flex">
          <div class="cart-goods">
            <img :src="item.imgUrl" alt />
          </div>
          <div class="cart-container flex2 jc-sb h100pc">
            <p class="goods-msg">{{ item.masterName }}</p>
            <div class="flex jc-sb aic" style="height: 28px">
              <span class="price">￥{{ item.price | formatMoney }}</span>

              <!-- 步进器 -->
              <van-stepper
                min="0"
                v-if="isEdit"
                :value="item.buyNum"
                async-change
                @plus="updateNum(item, 1)"
                @minus="updateNum(item, -1)"
              />
              <span v-else class="f999 f12">x {{ item.buyNum }}</span>
            </div>
          </div>
        </div>
      </div>
    </van-checkbox-group>

    <!-- 底部 -->
    <div v-if="cartList.length > 0">
      <van-submit-bar
        :loading="loading"
        v-if="isEdit"
        :price="3050"
        button-text="删除"
        @submit="showDialog"
      >
        <van-checkbox icon-size="15px" :value="allChecked" @click="selectAll"
          >全选</van-checkbox
        >
      </van-submit-bar>
      <van-submit-bar
        :loading="loading"
        v-else
        :price="totalMoney"
        button-text="结算"
        @submit="onSubmit"
      >
        <van-checkbox icon-size="15px" :value="allChecked" @click="selectAll"
          >全选</van-checkbox
        >
      </van-submit-bar>
    </div>

    <Footer></Footer>
  </div>
</template>

<script>
import { Checkbox, CheckboxGroup, Stepper, SubmitBar, Toast } from "vant";
import Footer from "@/components/Footer";
export default {
  components: {
    Footer,
    [Checkbox.name]: Checkbox,
    [Stepper.name]: Stepper,
    [SubmitBar.name]: SubmitBar,
    [CheckboxGroup.name]: CheckboxGroup,
  },
  data() {
    return {
      loading: false,
      // 是否全选
      allChecked: false,
      value: 1,
      isEdit: false,
      checked: true,
      result: [],
      cartList: [],
    };
  },

  computed: {
    isLogin() {
      return !!this.$store.state.token;
    },
    totalMoney() {
      let totalMoney = 0;
      let list = this.cartList.filter(item=> {
        return this.result.includes(item.cartId);
      })
      list.forEach((item) => {
        totalMoney += item.price * item.buyNum;
      });
      return totalMoney;
    },
    // 被选中的商品
    selectList() {
      return this.cartList.filter((item) => item.checked);
    },
  },
  created() {
    this.getCartList();
  },

  watch: {
    result() {
      if (this.result.length === this.cartList.length) {
        this.allChecked = true;
      } else {
        this.allChecked = false;
      }
    },
  },

  methods: {
    // 修改购买数量
    async updateNum(item, num) { 
      let buyNum = item.buyNum + num;
      if (buyNum == 0) {
        item.checked = true;
        this.$dialog
          .confirm({
            title: "温馨提示",
            message: "确定要删除吗",
          })
          .then(() => {
            this.delCart();
          })
          .catch(() => {
            item.buyNum = 1;
            item.checked = false;
          });
      } else {
        let url = "/cart/updateNum";
        try {
          let res = await this.$post(url, { buyNum, cartId: item.cartId });
          // Toast.success("修改成功");
          item.buyNum = buyNum;
        } catch (error) {}
      }
    },

    // 单选
    selectOne() {
      // 判断被选中的个数
      // let list = this.cartList;
      // let selectGoods = this.cartList.filter((item) => item.checked);
      // // 被选中的数量和总数量相比
      // if (selectGoods.length === list.length) {
      //   this.allChecked = true;
      // } else {
      //   this.allChecked = false;
      // }
    },

    // 全选和全部选
    selectAll() {
      this.allChecked = !this.allChecked;
      if (this.allChecked) {
        this.result = this.cartList.map((item) => item.cartId);
      } else {
        this.result = [];
      }
    },

    //获取购物车列表
    async getCartList() {
      try {
        this.$loading(true);
        let url = `/cart/all`;
        let res = await this.$axios.get(url);
        this.cartList = res.list;
      } catch (error) {
        this.$fail(error);
      }
      this.$loading(false);
    },

    // 提交订单
    async onSubmit() {
      if (this.result.length === 0) {
        this.$fail("请先选择商品");
        return false;
      } 
      this.$loading(true);
      let url = "/preOrder/create"; 
      let data = {
        cartId:this.result,
        totalMoney: this.totalMoney,
      };
      try {
        let res = await this.$post(url, data);
        let preOrderId = res.result.preOrderId;
        this.$router.push({
          path: "/order/submit/",
          query: { preOrderId },
        });
        // 把preOrderId保存到vuex,之后的页面很多要用到
        // this.$store.commit("updatePreOrderId", preOrderId);
        this.$loading(false);
      } catch (error) {
        this.$fail(error);
      }
    },

    showDialog() {
      if (this.result.length === 0) {
        this.$fail("请先选择商品");
        return false;
      }
      this.$dialog
        .confirm({
          title: "温馨提示",
          message: "确定要删除吗",
        })
        .then(() => {
          this.delCart();
        });
    },

    // 删除购物车
    async delCart() {
      // 选中的商品
      let url = `/cart/del`;
      this.loading = true;
      try {
        let cartId = this.result;
        let res = await this.$post(url, { cartId });
        // 把删除的商品去掉
        this.cartList = this.cartList.filter((item) => {
          return !cartId.includes(item.cartId);
        });
      } catch (error) {
        this.$fail(error);
      }
      this.loading = false;
    },

    // 跳转到详情
    toDetail(item) {
      // 非编辑情况下才能跳转
      if (!this.isEdit) {
        this.$router.push(`/product/detail/${item.productId}`);
      }
    },
  },
};
</script>

<style lang="less">
@import "./index.less";

.cart {
  .van-submit-bar {
    bottom: 50px;
  }
  .van-empty {
    height: 100vh;
    justify-content: flex-start;
    color: #c03131;
  }
  .empty {
    img {
      width: 80px;
      height: 80px;
    }
  }
}
</style>